export default __webpack_public_path__ + "static/media/ro.ea966c3d.svg";